(function () {
  'use strict';
  var R = window.Revzen || {};
  var umbralGlobal = R.envioGratis || 3900;
  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  function dinero(c) { return fmt.format((c || 0) / 100); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Promociones con fecha real: código de seguidores y Black Friday ----------
     El descuento lo aplica Shopify (código REVZEN por enlace / descuento automático BF).
     Aquí solo se enseña el mismo precio que se cobrará. */
  var PROMO = (function () {
    var P = R.promo || {}, ahora = new Date();
    function dia(txt, fin) {
      var p = (txt || '').split('-'); if (p.length !== 3) return null;
      return fin ? new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59) : new Date(+p[0], +p[1] - 1, +p[2], 0, 0, 0);
    }
    var bfIni = dia(P.bfInicio), bfFin = dia(P.bfFin, true), codFin = dia(P.codigoFin, true);
    var codigo = (P.codigo || '').toUpperCase();
    var ck = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    var conCodigo = !!(ck && codigo && decodeURIComponent(ck[1]).toUpperCase() === codigo);
    var bf = !!(bfIni && bfFin && ahora >= bfIni && ahora <= bfFin);
    var modo = bf ? 'bf' : (conCodigo && codFin && ahora <= codFin ? 'codigo' : '');
    return { modo: modo, d: modo ? Math.round((P.importe || 5) * 100) : 0, codigo: codigo, bfTexto: P.bfTexto || '' };
  })();
  (function () {
    if (!PROMO.modo) return;
    document.documentElement.classList.add('promo-' + PROMO.modo);
    /* Barra superior */
    $$('[data-anuncio]').forEach(function (a) {
      var txt = PROMO.modo === 'bf' ? PROMO.bfTexto : 'Código ' + PROMO.codigo + ' activado · −' + dinero(PROMO.d) + ' en cada producto';
      var li = a.querySelector('li'); (li || a).textContent = txt;
    });
    /* Tarjetas de producto */
    $$('[data-card]').forEach(function (c) {
      var el = c.querySelector('[data-card-precio]'); if (!el) return;
      var base = parseInt(el.getAttribute('data-card-precio'), 10) || 0;
      el.textContent = (el.getAttribute('data-card-desde') ? 'Desde ' : '') + dinero(base - PROMO.d);
      var antes = document.createElement('span'); antes.className = 'precio-antes'; antes.textContent = dinero(base);
      el.parentNode.appendChild(antes);
      if (PROMO.modo === 'bf' && !c.querySelector('.etiqueta')) {
        var e = document.createElement('span'); e.className = 'etiqueta etiqueta-bf'; e.textContent = 'BLACK FRIDAY'; c.insertBefore(e, c.firstChild);
      }
    });
  })();

  /* ---------- Aviso flotante ---------- */
  var toastT;
  function aviso(txt) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = txt;
    t.classList.add('visible');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('visible'); }, 2600);
  }

  /* ---------- Menú móvil ---------- */
  var menu = $('[data-menu]');
  var velo = $('[data-velo]');
  function cerrarTodo() {
    if (menu) menu.classList.remove('abierto');
    var c = $('[data-cajon]');
    if (c) { c.classList.remove('abierto'); c.setAttribute('aria-hidden', 'true'); }
    if (velo) velo.classList.remove('visible');
    document.body.style.overflow = '';
  }
  $$('[data-abrir-menu]').forEach(function (b) {
    b.addEventListener('click', function () { menu.classList.add('abierto'); velo.classList.add('visible'); b.setAttribute('aria-expanded', 'true'); });
  });
  $$('[data-cerrar-menu]').forEach(function (b) { b.addEventListener('click', cerrarTodo); });
  if (velo) velo.addEventListener('click', cerrarTodo);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarTodo(); });

  /* ---------- Carrito ---------- */
  var cajon = $('[data-cajon]');
  function abrirCajon() {
    if (!cajon) { location.href = '/cart'; return; }
    cajon.classList.add('abierto');
    cajon.setAttribute('aria-hidden', 'false');
    velo.classList.add('visible');
    document.body.style.overflow = 'hidden';
    var b = $('[data-cerrar-cajon]', cajon); if (b) b.focus();
  }
  $$('[data-cerrar-cajon]').forEach(function (b) { b.addEventListener('click', cerrarTodo); });
  $$('[data-abrir-cajon]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); pintarCarrito().then(abrirCajon); });
  });

  function pedirCarrito() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function pintarCarrito(carrito) {
    var p = carrito ? Promise.resolve(carrito) : pedirCarrito();
    return p.then(function (c) {
      $$('[data-contador]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-n', c.item_count); });
      if (!cajon) return c;
      var lista = $('[data-lista-carrito]', cajon);
      var pie = $('[data-pie-carrito]', cajon);
      var falta = umbralGlobal - c.total_price;
      var txt = $('[data-texto-envio]', cajon);
      var prog = $('[data-progreso]', cajon);
      if (c.item_count === 0) {
        lista.innerHTML = '<div class="vacio"><p>Tu carrito está vacío.</p></div>';
        pie.hidden = true;
        txt.textContent = 'Envío gratis a partir de ' + dinero(umbralGlobal);
        prog.style.width = '0%';
        return c;
      }
      pie.hidden = false;
      txt.innerHTML = falta > 0 ? 'Te faltan <strong>' + dinero(falta) + '</strong> para el envío gratis' : '<strong>¡Tienes envío gratis!</strong>';
      prog.style.width = Math.min(100, (c.total_price / umbralGlobal) * 100) + '%';
      lista.innerHTML = c.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>';
        var variante = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + it.variant_title + '</small>' : '';
        return '<div class="linea" data-key="' + it.key + '">' + img +
          '<div><h3>' + it.product_title + '</h3>' + variante +
          '<div class="linea-acc"><div class="cantidad"><button type="button" data-cambiar="-1" aria-label="Quitar uno">−</button><span style="min-width:22px;text-align:center;font-weight:700">' + it.quantity + '</span><button type="button" data-cambiar="1" aria-label="Añadir uno">+</button></div>' +
          '<button class="quitar" type="button" data-quitar>Quitar</button></div></div>' +
          '<b>' + dinero(it.final_line_price) + '</b></div>';
      }).join('');
      $('[data-subtotal]', cajon).textContent = dinero(c.items_subtotal_price);
      $('[data-total]', cajon).textContent = dinero(c.total_price);
      return c;
    });
  }

  function cambiarLinea(key, cantidad) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: cantidad })
    }).then(function (r) { return r.json(); }).then(pintarCarrito);
  }
  if (cajon) {
    cajon.addEventListener('click', function (e) {
      var linea = e.target.closest('[data-key]');
      if (!linea) return;
      var key = linea.getAttribute('data-key');
      var actual = parseInt($('.cantidad span', linea).textContent, 10) || 0;
      if (e.target.closest('[data-cambiar]')) {
        cambiarLinea(key, Math.max(0, actual + parseInt(e.target.closest('[data-cambiar]').getAttribute('data-cambiar'), 10)));
      } else if (e.target.closest('[data-quitar]')) {
        cambiarLinea(key, 0);
      }
    });
  }

  function anadir(form, irAPago) {
    var btn = $('[data-btn-anadir]', form);
    var datos = new FormData(form);
    if (btn) { btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo añadir'); return j; });
    }).then(function () {
      if (irAPago) { location.href = '/checkout'; return; }
      return pintarCarrito().then(function () { abrirCajon(); });
    }).catch(function (err) {
      aviso(err.message || 'No se pudo añadir. Inténtalo de nuevo.');
    }).then(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- Ficha de producto ---------- */
  var landing = $('[data-landing]');
  if (landing) {
    var form = $('[data-form-producto]', landing);
    var jsonEl = $('[data-producto-json]', landing);
    var producto = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var inputId = $('[data-variante-id]', landing);
    var cant = $('[data-cantidad]', landing);
    var btnAnadir = $('[data-btn-anadir]', landing);
    var btnYa = $('[data-comprar-ya]', landing);
    var envioLinea = $('[data-envio-linea]', landing);

    function varianteActual() {
      if (!producto) return null;
      var id = parseInt(inputId.value, 10);
      for (var i = 0; i < producto.variants.length; i++) if (producto.variants[i].id === id) return producto.variants[i];
      return producto.variants[0];
    }
    function pintarEnvio() {
      if (!envioLinea) return;
      var v = varianteActual(); if (!v) return;
      var total = (v.price - PROMO.d) * (parseInt(cant.value, 10) || 1);
      var umbral = parseInt(envioLinea.getAttribute('data-umbral'), 10) || umbralGlobal;
      envioLinea.innerHTML = total >= umbral
        ? '<strong>Envío GRATIS</strong> en este pedido'
        : 'Envío ' + envioLinea.getAttribute('data-envio') + ' · <strong>gratis a partir de ' + dinero(umbral) + '</strong>';
    }
    function pintarPrecios(v) {
      var final = v.price - PROMO.d;
      $$('[data-precio]', landing).forEach(function (el) { el.textContent = dinero(final); });
      var antes = $('[data-precio-antes]', landing), ahorro = $('[data-ahorro]', landing), nota = $('[data-promo-nota]', landing);
      if (PROMO.d) {
        antes.textContent = dinero(v.price); antes.hidden = false;
        ahorro.textContent = (PROMO.modo === 'bf' ? 'Black Friday −' : 'Código ' + PROMO.codigo + ' −') + dinero(PROMO.d); ahorro.hidden = false;
        if (nota) {
          nota.textContent = PROMO.modo === 'bf'
            ? 'Precio tachado: el más bajo de los últimos 30 días. El descuento se aplica solo en el carrito.'
            : 'Precio para seguidores: el código ' + PROMO.codigo + ' ya está aplicado y lo verás descontado al pagar.';
          nota.hidden = false;
        }
      } else if (v.compare_at_price && v.compare_at_price > v.price) {
        antes.textContent = dinero(v.compare_at_price); antes.hidden = false;
        ahorro.textContent = 'Ahorras ' + dinero(v.compare_at_price - v.price); ahorro.hidden = false;
      } else { antes.hidden = true; ahorro.hidden = true; }
      var pb = $('[data-precio-barra]', landing); if (pb) pb.textContent = dinero(final);
      var pc = $('[data-precio-cta]', landing); if (pc) pc.textContent = dinero(final);
      var ld = $('[data-lanz-despues]', landing), lz = $('[data-lanz]', landing);
      if (ld && lz) ld.textContent = dinero(v.price + (parseInt(lz.getAttribute('data-lanz-subida'), 10) || 0));
    }
    /* Precios de las opciones y etiqueta de ahorro con el descuento vigente */
    if (PROMO.d) {
      $$('[data-precio-op]', landing).forEach(function (el) { el.textContent = dinero((parseInt(el.getAttribute('data-precio-op'), 10) || 0) - PROMO.d); });
      var lp = $('[data-lanz-pill]', landing); if (lp && PROMO.modo === 'bf') lp.textContent = 'Black Friday';
    }
    $$('[data-pill-auto]', landing).forEach(function (el) {
      var u = parseInt(el.getAttribute('data-unidades'), 10) || 2, p1 = parseInt(el.getAttribute('data-p1'), 10) || 0, pk = parseInt(el.getAttribute('data-pk'), 10) || 0;
      var ah = u * (p1 - PROMO.d) - (pk - PROMO.d);
      if (ah > 0) el.textContent = 'AHORRA ' + dinero(ah); else el.hidden = true;
    });
    function pintarVariante(v) {
      if (!v) return;
      inputId.value = v.id;
      pintarPrecios(v);
      [btnAnadir, btnYa, $('[data-barra-anadir]', landing)].forEach(function (b) { if (b) b.disabled = !v.available; });
      var t = $('[data-txt-btn]', landing); if (t) t.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      if (v.featured_media) mostrarMedia(v.featured_media.id);
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
      pintarEnvio();
    }
    $$('[data-opcion]', landing).forEach(function (r) {
      r.addEventListener('change', function () {
        var sel = $$('[data-opcion]:checked', landing).map(function (x) { return x.value; });
        $$('[data-valor-opcion]', landing).forEach(function (el, i) { el.textContent = sel[i] || ''; });
        var v = producto.variants.filter(function (vv) { return vv.options.every(function (o, i) { return o === sel[i]; }); })[0];
        pintarVariante(v);
      });
    });
    var menos = $('[data-menos]', landing), mas = $('[data-mas]', landing);
    if (menos) menos.addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1); pintarEnvio(); });
    if (mas) mas.addEventListener('click', function () { cant.value = Math.min(10, (parseInt(cant.value, 10) || 1) + 1); pintarEnvio(); });
    if (cant) cant.addEventListener('change', pintarEnvio);

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); anadir(form, false); });
      if (btnYa) btnYa.addEventListener('click', function () { anadir(form, true); });
    }
    var barra = $('[data-barra-compra]', landing);
    var barraBtn = $('[data-barra-anadir]', landing);
    if (barraBtn && form) barraBtn.addEventListener('click', function () { anadir(form, false); });
    var cta = $('[data-cta-subir]', landing);
    if (cta) cta.addEventListener('click', function () {
      var f = $('.info', landing); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { if (btnAnadir) btnAnadir.focus({ preventScroll: true }); }, 600);
    });
    function revisarBarra() {
      if (!barra || !btnAnadir) return;
      var r = btnAnadir.getBoundingClientRect();
      var fuera = r.bottom < 0 || r.top > window.innerHeight;
      var visible = r.bottom < 0;
      barra.classList.toggle('visible', visible && fuera);
      barra.setAttribute('aria-hidden', String(!(visible && fuera)));
    }
    window.addEventListener('scroll', revisarBarra, { passive: true });
    revisarBarra();

    /* Galería */
    var pista = $('[data-pista]', landing);
    var puntos = $$('[data-puntos] button', landing);
    var minis = $$('[data-miniaturas] button', landing);
    var principal = $('[data-principal]', landing);
    var slides = pista ? $$('.slide', pista) : [];
    if (pista && puntos.length) {
      pista.addEventListener('scroll', function () {
        var i = Math.round(pista.scrollLeft / pista.clientWidth);
        puntos.forEach(function (p, k) { p.setAttribute('aria-current', String(k === i)); });
      }, { passive: true });
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { pista.scrollTo({ left: k * pista.clientWidth, behavior: 'smooth' }); }); });
    }
    function verIndice(i) {
      if (!slides[i]) return;
      if (principal) {
        principal.innerHTML = '';
        var copia = slides[i].firstElementChild ? slides[i].firstElementChild.cloneNode(true) : null;
        if (copia) {
          if (copia.tagName === 'IMG') { copia.removeAttribute('loading'); copia.sizes = '(min-width: 960px) 55vw, 100vw'; }
          principal.appendChild(copia);
          if (copia.tagName === 'VIDEO') { copia.muted = true; copia.play().catch(function () {}); }
        }
      }
      minis.forEach(function (m, k) { m.setAttribute('aria-current', String(k === i)); });
      if (pista && window.innerWidth < 960) pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' });
    }
    function mostrarMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { verIndice(i); return; }
    }
    minis.forEach(function (m) { m.addEventListener('click', function () { verIndice(parseInt(m.getAttribute('data-index'), 10)); }); });

    if (PROMO.d && varianteActual()) pintarPrecios(varianteActual());
    pintarEnvio();
  }

  /* ---------- Cuenta atrás real (precio de lanzamiento / corte de Navidad) ---------- */
  function cuentaAtras(caja, fin, alTerminar) {
    var c = {}; ['d', 'h', 'm', 's'].forEach(function (k) { c[k] = caja.querySelector('[data-c="' + k + '"]'); });
    var dos = function (n) { return (n < 10 ? '0' : '') + n; };
    var reloj;
    var tic = function () {
      var s = Math.floor((fin - new Date()) / 1000);
      if (s <= 0) { clearInterval(reloj); alTerminar(); return; }
      c.d.textContent = Math.floor(s / 86400);
      c.h.textContent = dos(Math.floor(s % 86400 / 3600));
      c.m.textContent = dos(Math.floor(s % 3600 / 60));
      c.s.textContent = dos(s % 60);
    };
    reloj = setInterval(tic, 1000); tic();
  }
  $$('[data-lanz]').forEach(function (lz) {
    var p = (lz.getAttribute('data-lanz-fin') || '').split('-');
    if (p.length !== 3) { lz.hidden = true; return; }
    var fin = new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59);
    cuentaAtras(lz, fin, function () { lz.hidden = true; });
  });

  /* ---------- Fecha estimada de entrega (días laborables, festivos nacionales) ---------- */
  var FESTIVOS = ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'];
  function esLaborable(d) {
    var w = d.getDay(); if (w === 0 || w === 6) return false;
    var k = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return FESTIVOS.indexOf(k) === -1;
  }
  function sumarLaborables(fecha, dias) {
    var d = new Date(fecha);
    while (dias > 0) { d.setDate(d.getDate() + 1); if (esLaborable(d)) dias--; }
    return d;
  }
  function restarLaborables(fecha, dias) {
    var d = new Date(fecha);
    while (dias > 0) { d.setDate(d.getDate() - 1); if (esLaborable(d)) dias--; }
    return d;
  }
  var fmtFecha = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
  var fmtDia = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long' });
  $$('[data-eta]').forEach(function (el) {
    var hoy = new Date(); hoy.setHours(12, 0, 0, 0);
    var min = parseInt(el.getAttribute('data-eta-min'), 10) || R.etaMin || 6;
    var max = parseInt(el.getAttribute('data-eta-max'), 10) || R.etaMax || 12;
    var a = sumarLaborables(hoy, min), b = sumarLaborables(hoy, max);
    el.textContent = 'Recíbelo entre el ' + fmtFecha.format(a) + ' y el ' + fmtFecha.format(b);
    /* Navidad: solo se muestra si es verdad con el plazo máximo */
    var caja = el.closest('.info') || document;
    var nav = caja.querySelector('[data-navidad]');
    if (!nav) return;
    var nochebuena = new Date(hoy.getFullYear(), 11, 24, 12);
    if (hoy.getMonth() < 10 || hoy > nochebuena) return;
    var limite = restarLaborables(nochebuena, max);
    if (b <= nochebuena) {
      /* Cuenta atrás real: termina el último día en que, con el plazo máximo, llega el 24.
         Si ya hay cuenta atrás del precio de lanzamiento, aquí solo va el texto. */
      var fin = new Date(limite); fin.setHours(23, 59, 59, 0);
      var lanz = caja.querySelector('[data-lanz]:not([hidden])');
      var celda = function (k, txt) { return '<div><strong data-c="' + k + '">00</strong><small>' + txt + '</small></div>'; };
      nav.innerHTML = '<b>🎄 Llega antes de Navidad</b><span>Pídelo hasta el ' + fmtDia.format(limite) + ' y lo tienes para el 24. Después puede no llegar a tiempo.</span>' +
        (lanz ? '' : '<div class="cuenta">' + celda('d', 'días') + celda('h', 'horas') + celda('m', 'min') + celda('s', 'seg') + '</div>');
      nav.hidden = false;
      if (!lanz) cuentaAtras(nav, fin, function () { nav.hidden = true; });
    }
  });

  /* ---------- ¿Vale para mi coche? (respuesta inmediata con base de datos) ---------- */
  function normaliza(x) {
    return (x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  $$('[data-compat]').forEach(function (caja) {
    var btn = caja.querySelector('[data-compat-btn]');
    var res = caja.querySelector('[data-compat-res]');
    var coche = caja.querySelector('[data-compat-coche]');
    var faro = caja.querySelector('[data-compat-faro]');
    if (!btn || !res) return;
    var db = null;
    var url = caja.getAttribute('data-compat-db');
    if (url) fetch(url).then(function (r) { return r.json(); }).then(function (d) { db = d; }).catch(function () {});
    function esc(x) { var d = document.createElement('div'); d.textContent = x; return d.innerHTML; }
    function buscar(texto) {
      if (!db || !db.length) return null;
      var q = ' ' + normaliza(texto) + ' ';
      var anio = (texto.match(/\b(19[89]\d|20[0-3]\d)\b/) || [])[0];
      anio = anio ? parseInt(anio, 10) : null;
      var mejor = null, mejorPts = 0;
      db.forEach(function (e) {
        var pts = 0, modelo = false;
        var claves = (e.alias || []).concat([e.modelo, e.marca + ' ' + e.modelo]);
        claves.forEach(function (al) {
          var n = normaliza(al);
          if (n.length > 1 && q.indexOf(' ' + n + ' ') !== -1) { pts += n.length; if (normaliza(e.marca) !== n) modelo = true; }
        });
        if (q.indexOf(' ' + normaliza(e.marca) + ' ') !== -1) pts += 2;
        if (!modelo) return;
        if (anio && e.anios && e.anios.length === 2) pts += (anio >= e.anios[0] && anio <= e.anios[1]) ? 8 : -12;
        if (pts > mejorPts) { mejorPts = pts; mejor = e; }
      });
      return mejorPts >= 3 ? mejor : null;
    }
    btn.addEventListener('click', function () {
      var nombre = (coche && coche.value.trim()) || '';
      var pesado = /cami[oó]n|tr[aá]iler|autob[uú]s|24 ?v/i.test(nombre);
      var e = nombre ? buscar(nombre) : null;
      var html = '';
      if (pesado) {
        html += '<p class="compat-no"><b>⚠️ Ojo:</b> este kit es para vehículos de 12 V. Los camiones y autobuses suelen ir a 24 V.</p>';
      } else if (e) {
        var icono = { si: '✅', segun_version: '🟡', dificil: '⚠️' }[e.veredicto] || '🟡';
        var clase = { si: 'compat-si', segun_version: 'compat-medio', dificil: 'compat-no' }[e.veredicto] || 'compat-medio';
        var titulo = { si: 'Compatible', segun_version: 'Compatible según la versión', dificil: 'Instalación difícil' }[e.veredicto] || 'Compatible según la versión';
        var gen = e.generacion || ''; var nom = gen.toLowerCase().indexOf(String(e.modelo).toLowerCase()) === 0 ? e.marca + ' ' + gen : e.marca + ' ' + e.modelo + ' ' + gen;
        html += '<p class="' + clase + '"><b>' + icono + ' ' + esc(nom.trim()) + ': ' + titulo + '.</b></p>';
        html += '<p>' + esc(e.texto) + '</p>';
        html += '<p class="gris">⚡ Eléctricamente vale: funciona a 12 V, como tu coche.</p>';
      } else {
        html += '<p class="compat-si"><b>✅ ' + esc(nombre || 'Tu coche') + ': eléctricamente compatible.</b> Funciona a 12 V, como prácticamente todos los coches, furgonetas y SUV.</p>';
        var t = {
          lupa: 'Tu faro tiene lupa: es el caso más fácil. El módulo de 3 pulgadas suele ir en el sitio de la lupa o junto a ella.',
          reflector: 'En faros sin lupa, comprueba que detrás del cristal hay hueco para un módulo de unos 9 cm de diámetro y unos 7 cm de fondo.',
          nose: 'Mira dentro del faro: si ves una lente redonda (una "lupa"), es el caso más fácil. Si no, comprueba que cabe un módulo de unos 9 cm de diámetro y unos 7 cm de fondo.'
        };
        html += '<p>📏 ' + (t[faro ? faro.value : 'nose']) + '</p>';
      }
      html += '<p>🔧 Se instala abriendo el faro. Si no lo has hecho nunca, cualquier taller de iluminación te lo monta.</p>';
      res.innerHTML = html; res.hidden = false;
    });
  });

  /* Contador del carrito al cargar (por si la página viene de caché) */
  if (cajon) pintarCarrito();
})();
